import React, { useEffect, useRef, useState } from "react";
import DataTable from "react-data-table-component";
// import Source from "../../../Source";
import Source from "../../../../Source";
import axios from "axios";
import Swal from "sweetalert2";
import { showAlert } from "../../../../warrper";
import Datepicker_Customer from "./../../../forms/Datepicker_customer";
import moment from "moment-jalaali";
import jalaali from "jalaali-js";
// import Combo_stock from "./../../../forms/Combo_Customer";
import ComboBo from'./ComboBo';
import Combo_item from "./../../../forms/Combo_Customer";
import Combo_Customer from "./../../../forms/Combo_Customer";
import ComboBox from "./../../../forms/ComboBox";
import Trash from "./../../../../assets/icon/trash.png";
import Print from "./../../../../assets/icon/print.png";
import Add from "./../../../../assets/icon/add.png";
import jsPDF from "jspdf";
import { useSelector, useDispatch } from "react-redux";
import { getSettings } from "./../../../Redux/settingSlice";
import { FormattedMessage,useIntl } from "react-intl";
import { useShowAlert  } from "../../../../warrper";
export default function EditSellReturn({
  AddSellModal,
  close,
  // settings,
  records,
  setRecords,
  moneys,
  shopingcart,setshopingcart,
  // addAccountModal,
  // setAddAccountModal,
  // setcustomer,customer,
  belance,
  setbelance,
  setAddBalanceModal,
  options1,
  setOptions1,
  SoldRecords,setSoldRecords,
  bill,setbill,
  money,setmoney,
  returnbill,setreturnbill,TotalAmount, setTotalAmount,PaidAmount, setPaidAmount
}) {
  const showAlert = useShowAlert(); 
  const dispatch = useDispatch();
  // const { customers, errorc, statusc } = useSelector(
  //   (state) => state.customers
  // );
  const { settings, errors, statuss } = useSelector((state) => state.settings);

  useEffect(() => {
    if (!statuss && settings?.lenght === 0) {
      dispatch(getSettings());
    }
  }, [dispatch, statuss]);
  // const { customers, errorc } = useSelector((state) => state.customers);
  const { items, errori } = useSelector((state) => state.items);
  const [selectedDay, setSelectedDay] = useState(moment());
  // const [selectedDay1, setSelectedDay1] = useState(moment());
  const [selectedOption, setSelectedOption] = useState();
  const [selectedOption1, setSelectedOption1] = useState();
  const [EndDate, setEndDate] = useState(moment());
  const [account, setaccount] = useState(false);
  const [update, setupdate] = useState({ id: 0, belance: 0 });
  const [selectedOptionAccount, setSelectedOptionAccount] = useState([]);
  const [ExestQty, setExestQty] = useState(0);
  const [AddItem, setAddItem] = useState({
    sell:null,
    item_id: "",
    qty: null,
    weight: null,
    dateInsert: new Date().toISOString(),
    rate: null,
    user_id: localStorage.getItem("userTokenid"),
    purchase_price: null,
    description: "",
    sell_price: null,
    expiry_date: new Date().toISOString(),
    accounts_id: "",
    money: "",
    stock: { name: "" },
    e_id: 1,
  });


  const [primari, setprimari] = useState(0);

  const algorithm = (e) => {
    if (e) {
      setAddItem({
        ...AddItem,
        accounts_id: e.id,
      });
    }
  };
  const algorithm1 = (e) => {
    setSelectedOption1(e);
    if (e) {
      setAddItem({
        ...AddItem,
        item_id: e.item_id,
        stock: e,
        sell:e.id
        // id:e.id
      });
    }
  };
  const handle_date = (jalaliDate) => {
    if (jalaliDate) {
      const { year, month, day } = jalaliDate;
      const gregorianDate = jalaali.toGregorian(year, month, day);
      // Get current time
      const now = new Date();
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      // Create the ISO date string
      let isoDateString;
      const t = new Date();
      const date = new Date(
        jalaliDate.year,
        jalaliDate.month - 1,
        jalaliDate.day,
        t.getHours(),
        t.getMinutes()
      );

      // const date = new Date(jalaliDate.year, jalaliDate.month - 1, jalaliDate.day);
      const isoString = date.toISOString(); // This gives you the ISO string in UTC
      // setIsoDate(isoString);
      setAddItem({
        ...AddItem,
        dateInsert: isoString,
      });
      // const isoDateString = `${year}-${month}-${day}T${hours}:${minutes}`;
    }
  };
  const date = (d) => {
    const date = new Date(d);
    let formattedDate = `${date.getFullYear()}-${String(
      date.getMonth() + 1
    ).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "pm" : "am";
    let aa = ampm;
    const formattedHours = hours % 12 || 12;
    const formattedMinutes = minutes < 10 ? "0" + minutes : minutes;
    if (settings[0].date === "Persian") {
      moment.locale("fa"); // تنظیم لوکال به فارسی
      aa = hours >= 12 ? "ب.ظ" : "ق.ظ";
      formattedDate = moment(d).format("jYYYY-jMM-jDD");
    } else {
      moment.locale("en"); // تنظیم لوکال به انگلیسی
    }

    return `${formattedDate} ${formattedHours}:${formattedMinutes} ${aa}`;
  };

  const capitalizeWords = (text) => {
    return text
      .toLowerCase() // همه حروف را کوچک کنید
      .split(" ") // متن را به آرایه‌ای از کلمات تقسیم کنید
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // حروف اول هر کلمه را بزرگ کنید
      .join(" "); // کلمات را به هم وصل کنید
  };
  const generateInvoicePDF = (id) => {
    const doc = new jsPDF();

    // Title Section
    doc.setFontSize(26);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(11, 105, 255); // Blue color for title
    doc.text("Invoice", 105, 10, null, null, "center");

    doc.setFontSize(14);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(0, 0, 0); // Black color for text
    doc.text(`${settings[0].company_name}`, 105, 20, null, null, "center");
    doc.setFontSize(12);
    doc.text(
      `Seller Name: ${
        selectedOption ? capitalizeWords(selectedOption.name) : "N/A"
      }`,
      105,
      28,
      null,
      null,
      "center"
    );

    // Invoice Details Section
    doc.setFontSize(14);
    doc.setTextColor(11, 105, 255); // Blue color for the section heading
    doc.text(`Invoice Number: ${id}`, 5, 19);
    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0); // Black color for text

    const date = new Date(selectedDay);
    let formattedDate = `${date.getFullYear()}-${String(
      date.getMonth() + 1
    ).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "pm" : "am";
    let aa = ampm;
    const formattedHours = hours % 12 || 12;
    const formattedMinutes = minutes < 10 ? "0" + minutes : minutes;
    if (localStorage.getItem("date") === "Persian") {
      moment.locale("fa"); // تنظیم لوکال به فارسی
      aa = hours >= 12 ? "pm" : "am";
      formattedDate = moment(selectedDay).format("jYYYY/jMM/jDD");
    } else {
      moment.locale("en"); // تنظیم لوکال به انگلیسی
    }
    const fromdata = `${formattedDate} ${formattedHours}:${formattedMinutes} ${aa}`;
    // return `${formattedDate} ${formattedHours}:${formattedMinutes} ${aa}`;
    // doc.text(`Date: ${selectedDay ? date(selectedDay) : 'N/A'}`, 5, 29);
    doc.text(`Date:${fromdata}`, 5, 29);

    // Draw Horizontal Line
    doc.setDrawColor(0, 0, 0); // Black color for line
    doc.setLineWidth(0.5);
    doc.line(5, 35, 205, 35);

    // Company Image
    if (settings[0].company_pic) {
      const url = settings[0].company_pic;
      const fileName = url.split("/").pop();
      doc.addImage(
        Source.getAddress() + "/api/getImage/" + fileName,
        "JPEG",
        180,
        5,
        25,
        25
      );
    } else {
      doc.setFontSize(12);
      doc.text("No Company Image Available", 150, 20);
    }

    // Table with Purchase Details
    doc.autoTable({
      startY: 40,
      head: [["No", "Name", "Quantity", "Price", "Total"]],
      body: shopingcart.map((row) => [
        row.e_id,
        row.stock.name,
        row.qty,
        row.sell_price +
          `${selectedOptionmoney ? selectedOptionmoney.name : "N/A"}`,
        row.sell_price * row.qty +
          `${selectedOptionmoney ? selectedOptionmoney.name : "N/A"}`,
      ]),
      theme: "grid",
      headStyles: {
        fillColor: [11, 105, 255],
        textColor: [255, 255, 255],
        fontSize: 10,
        fontStyle: "bold",
      },
      bodyStyles: {
        fontSize: 10,
        textColor: [0, 0, 0],
        fillColor: [255, 255, 255],
      },
      alternateRowStyles: {
        fillColor: [245, 245, 245],
      },
    });

    // Footer Section Positioned Dynamically
    const finalY = doc.lastAutoTable.finalY || 40; // Ensure there's a fallback
    doc.setFontSize(9);
    doc.setTextColor(0, 0, 0); // Black color for text

    // Amount Details Section
    doc.text(
      `Total Amount: ${TotalAmount}` +
        `${selectedOptionmoney ? selectedOptionmoney.name : "N/A"}`,
      152,
      finalY + 5
    );
    doc.text(
      `Paid Amount: ${PaidAmount ? PaidAmount : "0.00"}` +
        `${selectedOptionmoney ? selectedOptionmoney.name : "N/A"}`,
      152,
      finalY + 10
    );
    doc.text(
      `Belance: ${update.belance}` +
        `${selectedOptionmoney ? selectedOptionmoney.name : "N/A"}`,
      152,
      finalY + 15
    );

    // Draw Horizontal Line
    if (finalY + 15 > 144) {
      doc.setDrawColor(0, 0, 0);
      doc.setLineWidth(0.5);
      doc.line(5, 278, 205, 278);
      doc.text(`Address: ${settings[0].address}`, 10, 283);
      doc.text(`Phone: ${settings[0].phone}`, 80, 283);
      doc.text(`Email: ${settings[0].email}`, 140, 283);
    } else {
      doc.setDrawColor(0, 0, 0);
      doc.setLineWidth(0.5);
      doc.line(5, 139, 205, 139);
      // Footer Address
      doc.setFontSize(12);
      // doc.addImage(AddAddress, 'png', 180, 5, 25, 25);
      doc.text(`Address: ${settings[0].address}`, 10, 144);
      doc.text(`Phone: ${settings[0].phone}`, 80, 144);
      doc.text(`Email: ${settings[0].email}`, 140, 144);
    }

    // Save the document as a PDF
    const pdfURL = doc.output("bloburl");
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = pdfURL;
    document.body.appendChild(iframe);
    iframe.contentWindow.print();
  };
  // console.log(bill);
  const Sumbit = (flag) => {
    let BillId = 0;
    // if (shopingcart.length <= 0) {
    //   showAlert({
    //     position: "top-end",
    //     icon: "error",
    //     title: "You must fill the item input!",
    //     showConfirmButton: false,
    //     timer: 1000,
    //   });
    //   return;
    // }
    let arr = [];
    shopingcart.forEach((key) => {
      arr.push({
        sell:key.sell,
        item_id: key.item_id,
        qty:parseInt(key.qty),
        weight: key.weight,
        dateInsert: key.dateInsert,
        rate: key.rate,
        user_id: key.user_id,
        sell_price: key.sell_price,
        description: key.description,
        expiry_date: key.expiry_date,
        bill_id: "",
        accounts_id: key.accounts_id,
      });
    });
    // console.log(arr);
    let add = { arr: arr ,
      _method:"put"
    };
    axios
      .post(Source.getAddress() + "/api/sellreturn/"+returnbill.id, add, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access")}`,
        },
        params: {
          Exesting: bill?.accounts_id ? "ok" : "no",
          money: bill?.money_id || 0,
          accounts_id: bill.accounts?.account_id,
          PaidAmount: PaidAmount ? PaidAmount : 0,
          TotalAmount: TotalAmount,
          CustomerName: bill.temp_customer,
          DateInsert: selectedDay,
          bill_id:bill.id,
        },
      })
      .then((res) => {
        if (flag) {
          generateInvoicePDF(res.data.bill.id);
        }
        res.data.bill["money"] = money;
        res.data.bill["accounts"] = { account: bill?.accounts?.account };
        res.data.bill["temp_customer"] = bill.temp_customer;
        BillId = res.data.bill.id;
        let add = {
          sells: shopingcart,
          bill: res.data.bill,
          money: money,
        };
        console.log(res);
        setRecords([add, ...records]);
        setSelectedDay(moment());
        setSelectedOption({ name: "" });
        setSelectedOption1({ name: "", type: { measuring: "" } });
        setEndDate(moment());
        setprimari(0);
        setAddItem({
          stocks_id: 0,
          qty: 0,
          weight: 0,
          dateInsert: new Date().toISOString(),
          rate: 0,
          user_id: localStorage.getItem("userTokenid"),
          purchase_price: 0,
          description: "Description",
          sell_price: 0,
          expiry_date: new Date().toISOString(),
          accounts_id: "",
        });
        setSearchQuery("");
        setSearchQuery1("");
        setSelectedOptionmoney({ name: "" });
        setaccount(false);
        setSelectedDay(moment());
        setSelectedOption();
        setSelectedOptionmoney();
        setExestQty(0);
        showAlert({
          position: "top-end",
          icon: "success",
          // title: "Stock has been created!",
                                                                title: <FormattedMessage id="Your record has been added!" />,
          showConfirmButton: false,
          timer: 1000,
        });
      })
      .catch((err) => {
        console.error(err);
        showAlert({
          position: "top-end",
          icon: "error",
          // title: "Sosmething went wrong!",
          title:  <FormattedMessage id="You must enter the customer name!" />,
          showConfirmButton: false,
          timer: 1000,
        });
      });
  };
  const AddtoTable = () => {
    if (!AddItem.qty) {
      showAlert({
        position: "top-end",
        icon: "error",
        // title: "Select an item!",
                        title:  <FormattedMessage id="Select an item!" />,
        showConfirmButton: false,
        timer: 1000,
      });
      return;
    }
    const qty = AddItem.qty ? parseInt(AddItem.qty) : 0;
    const sellPrice = AddItem.sell_price ? parseFloat(AddItem.sell_price) : 0;
    if (parseInt(selectedOption1.qty) - qty < 0) {
      showAlert({
        position: "top-end",
        icon: "error",
        // title: "have not enuagh item!",
                        title:  <FormattedMessage id="have not enuagh item!" />,
        showConfirmButton: false,
        timer: 1000,
      });
      return;
    }
    if (!qty || !sellPrice || !selectedOption1) {
      showAlert({
        position: "top-end",
        icon: "error",
        // title: "Please select an item and fill the quantity and price!",
                                          title:  <FormattedMessage id="Please select an item and fill the quantity and price!" />,
        showConfirmButton: false,
        timer: 1000,
      });
      return;
    }
      if (qty <= 0 || sellPrice <= 0) {
      showAlert({
        position: "top-end",
        icon: "error",
        // title: "Quantity and price must be positive values!",
                        title:  <FormattedMessage id="Quantity and price must be positive values!" />,

        showConfirmButton: false,
        timer: 1000,
      });
      return;
    }
    const addto ={...selectedOption1,...{sell:AddItem.sell}};
    setSoldRecords((prevRecords) => 
      prevRecords.map((row) => {
    if (row.id === selectedOption1.id) {
      // console.log(row);
      const updatedQty = parseInt(row.qty, 10) - parseInt(AddItem.qty, 10);
      // console.log({ ...row, qty: updatedQty });
      return { ...row, qty: updatedQty };
    }
    return row;
  })
);
addto.qty=AddItem.qty;
setshopingcart((prev) => [
  ...shopingcart,
  addto
]);

setPaidAmount((prev) => prev + qty * sellPrice);
setTotalAmount((prev) => prev + qty * sellPrice);
setAddItem({
  stocks_id: "",
  qty: "",
  weight: null,
  dateInsert: new Date().toISOString(),
  rate: null,
  user_id: localStorage.getItem("userTokenid"),
  purchase_price: "",
  description: "",
  sell_price: "",
  expiry_date: new Date().toISOString(),
  accounts_id: "",
  money: "",
  stock: { name: "" },
  e_id: AddItem.e_id + 1,
});
// بازنشانی selectedOption1
setSelectedOption1(null);

};
  const handleItem = (e) => {
    setAddItem({
      ...AddItem,
      [e.target.name]: e.target.value,
    });
  };

  const [options, setOptions] = useState();
  const handleSearch = async (query) => {
    if (!Exesting) {
      if (query) {
        setAddItem({
          ...AddItem,
          temp_customer: query,
        });
        setSelectedOption({ id: 0, name: query });
      }
    }
  };
  const handleSearch1 = async (query) => {
  };
  const handleInputChange = (newValue) => {
    setSearchQuery(newValue); // بروزرسانی مقدار ورودی جستجو
    handleSearch(newValue); // ارسال درخواست جستجو به سرور
  };
  const handleInputChange1 = (newValue) => {
    setSearchQuery1(newValue); // بروزرسانی مقدار ورودی جستجو
    handleSearch1(newValue); // ارسال درخواست جستجو به سرور
  };
  const [searchQuery, setSearchQuery] = useState("");
  const [searchQuery1, setSearchQuery1] = useState("");

  const [selectedOptionmoney, setSelectedOptionmoney] = useState({ name: "" });
  const algorithmmoney = (e) => {
    if (e) {
      setAddItem({
        ...AddItem,
        money: e.id,
      });
    }
  };
  const Deleteshopingcart = (e) => {
    setSoldRecords((prev) => 
      prev.map((row) => 
        row.id === e.sell ? { ...row, qty: row.qty + e.qty } : row
      )
    );
    setTotalAmount((prev) => parseInt(prev) - parseInt(e.qty * e.sell_price));
    setPaidAmount((prev) =>  parseInt(prev)  - parseInt(e.qty * e.sell_price));
    setshopingcart((prev) => prev.filter((pre) => pre.id !== e.id));
  };
  const buttonRef = useRef(null);
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (buttonRef.current && AddSellModal) {
        buttonRef.current.click();
      }
    }
  };
  const handlepaid = (e) => {
    setPaidAmount(e.target.value);
  };
  useEffect(() => {
    if (!PaidAmount) {
      setupdate((prevState) => ({
        ...prevState,
        belance: -TotalAmount,
      }));
    } else {
      setupdate((prevState) => ({
        ...prevState,
        belance: PaidAmount - TotalAmount || 0,
      }));
    }

    // }
  }, [PaidAmount, TotalAmount, shopingcart]);
  const [Exesting, setExesting] = useState();
  const [id,setid]=useState();
  console.log(shopingcart);
  let e_id=0;
  const { formatMessage } = useIntl();
  return (
    <div
  dir={localStorage.getItem("language") === "en" ? "ltr" : "rtl"}
  className={`container rounded-5 popup transition ${account && "sellpurchase"} ${AddSellModal ? "show" : ""}`}
  style={{
    width: "100%",
    maxWidth: "80%",  // Reduced the max width to 80%
    overflowX: "auto",
    overflowY: "auto",
    height: "75vh",  // Reduced the height to 75% of the viewport height
    backgroundColor: "#f8f9fa",
    padding: "5px",  // Reduced the padding
  }}
>
  <div className="d-flex justify-content-end">
    <h2
      className="text-center rounded p-1 text-light"
      style={{
        backgroundColor: "var(--bs-info)",
        width: "100%",
        marginTop: "0rem",
      }}
    >
      <FormattedMessage id="Edit Return Sell" />
    </h2>
    <button
      type="button"
      className="btn-close p-3 mt-0 hover_btn"
      onClick={close}
      aria-label="Close"
    ></button>
  </div>
  <div className="p-1 rounded-5">
    <div
      className="d-flex flex-column flex-md-row"
      style={{
        marginTop: "1rem",
        overflow: "auto",
      }}
    >
      <div className="col-12 col-md-8">
        <div
          className="rounded-3 px-4 p-1 mb-2"
          style={{
            // boxShadow: "2px 2px 2px 0 rgba(0, 0, 0, 0.2), 0 0px 2px 2px rgba(0, 0, 0, 0.1)",
          boxShadow: "0px 4px 0px 0 rgba(0, 0, 0, 0.2), 0 0px 0px 0px rgba(0, 0, 0, 0.1)"
          }}
        >
          <h2 className="mt-1"><FormattedMessage id="Search Bill" /></h2>
          <div className="d-flex flex-column flex-md-row">
            <div className="w-100 w-md-auto">
              <label htmlFor="phone_number" style={{ fontWeight: "bold" }}>
                <FormattedMessage id="Bill Number" />
              </label>
              <input
                readOnly={true}
                value={bill.id}
                type="number"
                name="Bill Number"
                placeholder={formatMessage({ id: "Bill Number" })}
                className="form-control fs-6 mb-3"
                style={{ width: "100%" }}
              />
            </div>
            <div className="form-item ms-4 w-100 w-md-auto">
              <label htmlFor="customer_name" style={{ fontWeight: "bold" }}>
                <FormattedMessage id="Customer Name" />
              </label>
              <input
                readOnly={true}
                value={bill?.temp_customer || bill.accounts?.account.name}
                type="text"
                name="customer_name"
                placeholder={formatMessage({ id: "Customer Name" })}
                className="form-control fs-6 mb-3"
                style={{ width: "100%" }}
              />
            </div>
          </div>
        </div>
        <div
          className="rounded-3 px-4 p-1 mb-2"
          style={{
            // boxShadow: "2px 2px 2px 0 rgba(0, 0, 0, 0.2), 0 0px 2px 2px rgba(0, 0, 0, 0.1)",
          boxShadow: "0px 4px 0px 0 rgba(0, 0, 0, 0.2), 0 0px 0px 0px rgba(0, 0, 0, 0.1)"
          }}
        >
          <h2 className="mt-1"><FormattedMessage id="Customer Info" /></h2>
          <div className="d-flex flex-column flex-md-row">
            <div className="form-item me-3 w-100 w-md-auto">
              <label htmlFor="Date" style={{ fontWeight: "bold" }}>
                <FormattedMessage id="Date" />
              </label>
              <input
                readOnly={true}
                value={bill?.dateInsert && date(bill?.dateInsert)}
                type="text"
                name="Date"
                placeholder={formatMessage({ id: "Date" })}
                className="form-control fs-6 mb-3"
                style={{ width: "100%" }}
              />
            </div>
            <div className="form-item me-3 w-100 w-md-auto">
              <label htmlFor="Total" style={{ fontWeight: "bold" }}>
                <FormattedMessage id="Total Amount" />
              </label>
              <input
                readOnly={true}
                value={bill?.total && String(bill?.total) + " " + bill.money?.name}
                type="text"
                name="Total"
                placeholder={formatMessage({ id: "Total Amount" })}
                className="form-control fs-6 mb-3"
              />
            </div>
            <div className="form-item me-3 w-100 w-md-auto">
              <label htmlFor="Paid" style={{ fontWeight: "bold" }}>
                <FormattedMessage id="Paid Amount" />
              </label>
              <input
                readOnly={true}
                value={bill?.PaidAmount && bill?.PaidAmount + " " + bill.money?.name}
                type="text"
                name="Paid"
                placeholder={formatMessage({ id: "Paid Amount" })}
                className="form-control fs-6 mb-3"
                style={{ width: "100%" }}
              />
            </div>
            <div className="form-item me-3 w-100 w-md-auto">
              <label htmlFor="remain" style={{ fontWeight: "bold" }}>
                <FormattedMessage id="Remain Amount" />
              </label>
              <input
                readOnly={true}
                value={bill?.Remain && bill?.Remain + " " + bill.money?.name}
                type="text"
                name="remain"
                placeholder={formatMessage({ id: "Remain Amount" })}
                className="form-control fs-6 mb-3"
                style={{ width: "100%" }}
              />
            </div>
          </div>
        </div>
        <div
          className="rounded-3 px-4 p-1 mb-1"
          style={{
            // boxShadow: "2px 2px 2px 0 rgba(0, 0, 0, 0.2), 0 0px 2px 2px rgba(0, 0, 0, 0.1)",
          boxShadow: "0px 4px 0px 0 rgba(0, 0, 0, 0.2), 0 0px 0px 0px rgba(0, 0, 0, 0.1)"
          }}
        >
          <h2 className="mt-3"><FormattedMessage id="Item infomation" /></h2>
          <div className="d-flex flex-column flex-md-row mb-1">
            <div className="me-3 w-100 w-md-16rem">
              <label htmlFor="validationServer01" className="fw-bold">
                <FormattedMessage id="Item Name" />
              </label>
              <ComboBo
                searchQuery={searchQuery1}
                setSearchQuery={setSearchQuery1}
                handleInputChange={handleInputChange1}
                handleSearch={handleSearch1}
                setSelectedOption={algorithm1}
                selectedOption={selectedOption1}
                options={SoldRecords}
              />
            </div>
            <div className="me-3 w-100 w-md-6rem">
              <label htmlFor="phone_number" style={{ fontWeight: "bold" }}>
                <FormattedMessage id="Quantity" />
              </label>
              <input
                onKeyDown={handleKeyDown}
                onChange={handleItem}
                value={AddItem.qty}
                type="number"
                name="qty"
                placeholder={formatMessage({ id: "Quantity" })}
                className="form-control fs-6 mb-3"
                style={{ width: "100%" }}
              />
            </div>
            <div className="me-3 w-100 w-md-8rem">
              <label htmlFor="phone_number" style={{ fontWeight: "bold" }}>
                <FormattedMessage id="Sell Price" />
              </label>
              <input
                onKeyDown={handleKeyDown}
                onChange={handleItem}
                value={AddItem.sell_price}
                type="number"
                name="sell_price"
                placeholder={formatMessage({ id: "Sell Price" })}
                className="form-control fs-6 mb-2"
                style={{ width: "100%" }}
              />
            </div>
            <div className="me-4 w-100 w-md-10rem">
              <label htmlFor="phone_number" style={{ fontWeight: "bold" }}>
                <FormattedMessage id="Total Amount" />
              </label>
              <input
                readOnly={true}
                onKeyDown={handleKeyDown}
                onChange={handleItem}
                value={AddItem.qty * AddItem.sell_price}
                type="text"
                name="qty"
                placeholder={formatMessage({ id: "Total Amount" })}
                className="form-control fs-6 mb-3"
                style={{ width: "100%" }}
              />
            </div>
            <div className="form-floating w-100 w-md-18rem">
              <textarea
                name="description"
                className="form-control h-50"
                placeholder={formatMessage({ id: "Description" })}
                id="floatingTextarea2"
                value={AddItem.description}
                onChange={handleItem}
              />
              <label htmlFor="floatingTextarea2">
                <FormattedMessage id="Description" />
              </label>
            </div>
            <button
              onClick={() => AddtoTable()}
              type="button"
              ref={buttonRef}
              className="btn btn-success p-1 m-4 w-100 w-md-8rem mt-4 mx-2"
            >
              <img src={Add} style={{ width: "20px", height: "20px" }} alt="Add" />
            </button>
          </div>
        </div>
      </div>
      <div className="col-12 col-md-4 ms-2">
        <div
          className="m-2 mt-0"
          style={{ maxHeight: "200px", height:"200px",overflow: "auto" }}
        >
          <h3
            className="text-center rounded p-2 text-light"
            style={{
              backgroundColor: "var(--bs-info)",
              width: "100%",
              marginTop: "0rem",
            }}
          >
            <FormattedMessage id="Item Sold" />
          </h3>
          <div className="table-responsive">
            <table className="table table-light table-striped">
              <thead>
                <tr>
                  <th scope="col"><FormattedMessage id="Name" /></th>
                  <th scope="col"><FormattedMessage id="Quantity" /></th>
                  <th scope="col"><FormattedMessage id="Price" /></th>
                  <th scope="col"><FormattedMessage id="Description" /></th>
                </tr>
              </thead>
              <tbody className="table-group-divider">
                {SoldRecords &&
                  SoldRecords.map((row, idx) => (
                    <tr key={idx}>
                      <td>{row.stock.name}</td>
                      <td>{row.qty}</td>
                      <td>{row.sell_price}</td>
                      <td>{row.description}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
        <label htmlFor="phone_number" style={{ fontWeight: "bold", marginTop: "1rem" }}>
        <FormattedMessage id="Total Return Amount" />
      </label>
      <input
        readOnly={true}
        onChange={handleItem}
        value={TotalAmount}
        type="text"
        className="form-control fs-6"
        style={{ width: "100%" }}
      />
      <label htmlFor="phone_number" style={{ fontWeight: "bold" }}>
        <FormattedMessage id="Paid Return Amount" />
      </label>
      <input
        readOnly={!Exesting}
        onKeyDown={handleKeyDown}
        onChange={handlepaid}
        value={PaidAmount}
        type="text"
        className="form-control fs-6"
        style={{ width: "100%" }}
      />
      <label htmlFor="phone_number" style={{ fontWeight: "bold" }}>
        <FormattedMessage id="Remain Return Amount" />
      </label>
      <input
        readOnly={true}
        value={update.belance}
        type="number"
        className="form-control fs-6 mb-2"
        style={{ width: "100%" }}
      />
    
      </div>
    </div>
  </div>
  <div className="row m-0 p-0">
    <div className="col-12 col-md-8">
      <div
        className="row"
        style={{
          maxHeight: "400px",
          overflow: "auto",
        }}
      >
        <h3
          className="text-center rounded p-2 text-light"
          style={{
            backgroundColor: "var(--bs-info)",
            width: "100%",
            marginTop: "0rem",
          }}
        >
          <FormattedMessage id="Return Item Sold" />
        </h3>
        <div className="table-responsive">
          <table className="table table-light table-striped">
            <thead>
              <tr>
                <th scope="col"><FormattedMessage id="No" /></th>
                <th scope="col"><FormattedMessage id="Name" /></th>
                <th scope="col"><FormattedMessage id="Quantity" /></th>
                <th scope="col"><FormattedMessage id="Price" /></th>
                <th scope="col"><FormattedMessage id="Total" /></th>
                <th scope="col"><FormattedMessage id="Description" /></th>
                <th scope="col"><FormattedMessage id="Delete" /></th>
              </tr>
            </thead>
            <tbody className="table-group-divider">
              {shopingcart &&
                shopingcart.map((row, idx) => (
                  <tr key={idx}>
                    <th scope="row">{row.id}</th>
                    <td>{row.stock?.name}</td>
                    <td>{row.qty}</td>
                    <td>{row.sell_price}</td>
                    <td>{row.sell_price * row.qty}</td>
                    <td>{row.description}</td>
                    <td style={{ width: "5%" }}>
                      <button
                        style={{
                          border: "none",
                          background: "transparent",
                        }}
                        onClick={() => Deleteshopingcart(row)}
                      >
                        <img
                          height={"50%"}
                          width={"50%"}
                          src={Trash}
                          alt="Delete"
                        />
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div className="col-12 col-md-4">
      <div className="date-picker-container">
        <Datepicker_Customer
          default_value={EndDate}
          handle_date={handle_date}
          lebal={<FormattedMessage id="Date" />}
          setSelectedDay={setSelectedDay}
          selectedDay={selectedDay}
        />
      </div>
      <div className="col-12 d-flex justify-content-center" style={{ marginTop: "1rem" }}>
        <button
          type="button"
          className="text-center btn btn-danger text-light me-2"
          style={{ width: "150px" }}
          onClick={close}
        >
          <FormattedMessage id="Cancel" />
        </button>
        <button
          type="button"
          className="text-center btn btn-success text-light ms-2"
          style={{ width: "150px" }}
          onClick={() => Sumbit(false)}
        >
          <FormattedMessage id="Save" />
        </button>
      </div>
    </div>
  </div>
</div>

  );
}
